import {SummaryModel} from '../../../../common/entity/summary.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';

export class CommunicationContentModelSummaryModel implements SummaryModel {
    id: number;
    label: string;
    type: LovValueSummary;
    permissions: PermissionsModel;
    active: boolean;
}
